
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component
export default class CustomerOrderActions extends Vue {
  $refs!: {};

  /* Properties */
  @Prop({ required: true }) orderId!: string;

  /* Store Actions */

  /* Watchers */

  /* Data */
  customerOrderActions = [{ id: 0, action: 'Reorder' }];

  /* Utility Functions */
  handleOptionSelection(action: string) {
    switch (action) {
      case 'Reorder':
        this.$router.push({
          name: 'OrderView',
          params: { reorderId: this.orderId }
        });
        break;
    }
  }

  /* Loaders */

  /* Mounted */

  /* Created */

  /* Emmited Functions */
}
